import React from 'react';

export function SignUp() {
  return (
    <>
      <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5405 7.39857C15.5405 10.1824 13.2838 12.4391 10.5 12.4391C7.71615 12.4391 5.45942 10.1824 5.45942 7.39857C5.45942 4.61475 7.71615 2.35802 10.5 2.35802C13.2838 2.35802 15.5405 4.61475 15.5405 7.39857ZM13.6978 13.1054C15.6926 11.9852 17.0405 9.84928 17.0405 7.39857C17.0405 3.78632 14.1122 0.858025 10.5 0.858025C6.88772 0.858025 3.95942 3.78632 3.95942 7.39857C3.95942 9.84928 5.30729 11.9852 7.30214 13.1054C5.78593 13.6026 4.39197 14.4512 3.24256 15.6006C1.31778 17.5254 0.23645 20.136 0.23645 22.858H1.73645C1.73645 20.5338 2.65975 18.3048 4.30322 16.6613C5.9467 15.0178 8.17573 14.0945 10.5 14.0945C12.8242 14.0945 15.0532 15.0178 16.6967 16.6613C18.3402 18.3048 19.2635 20.5338 19.2635 22.858H20.7635C20.7635 20.136 19.6821 17.5254 17.7574 15.6006C16.608 14.4512 15.214 13.6026 13.6978 13.1054Z"
          fill="#616568"
        />
      </svg>
      Sign Up
    </>
  );
}
